export default __webpack_public_path__ + "static/media/client.79244968.pdf";